import { ResponseStatus } from "src/constants/api/error-messages.const";

export default function AxiosResponse(response) {
  if (response.status === ResponseStatus.validStatus) {
    return response.data;
  }
  return response;
}
